module.exports = __webpack_public_path__ + "img/ai5.4b183b1b.png";